import * as React from "react";
import { RadioButton, RadioButtonGroup } from "azure-devops-ui/RadioButton";
import { Card } from "azure-devops-ui/Card";
import { ObservableValue } from "azure-devops-ui/Core/Observable";

export default class RadioButtonGroupExample extends React.Component {
    private selectedRadioButton = new ObservableValue<string>("");

    public render() {
        return (
            <Card>
                <RadioButtonGroup
                    onSelect={selectedId => (this.selectedRadioButton.value = selectedId)}
                    selectedButtonId={this.selectedRadioButton}
                    text={"How satisfied are you with your experience?"}
                >
                    <RadioButton id="option1" text="Very satisfied" key="option1" />
                    <RadioButton id="option2" text="Somewhat satisfied" key="option2" />
                    <RadioButton id="option3" text="Somewhat dissatisfied" key="option3" />
                    <RadioButton id="option4" text="Very dissatisfied" key="option4" />
                </RadioButtonGroup>
            </Card>
        );
    }
}
